import React from "react"
import styled from "styled-components"

interface Props {
  isShow: boolean
}

interface StyledProps {
  src: string
}

const ExpandButton = (props: Props) => {
  const { isShow } = props

  const plusIcon = "/images/icons/plus.svg"
  const minusIcon = "/images/icons/minus.svg"

  return (
    <Wrapper>
      <Icon src={isShow ? minusIcon : plusIcon} />
    </Wrapper>
  )
}

export default ExpandButton

const Wrapper = styled.div`
  display: grid;
  width: 30px;
  height: 30px;
  border: 1px solid #000000;
  box-shadow: inset 0px 3px 3px rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  cursor: pointer;

  &,
  * {
    transition: 0.8s cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  :hover {
    transform: scale(1.1);
  }

  @media (prefers-color-scheme: dark) {
    border: 1px solid #ffffff;
  }
`

const Icon = styled.div<StyledProps>`
  margin: auto;
  width: 24px;
  height: 24px;
  mask-image: url(${props => props.src || "/images/icons/plus.svg"});
  mask-repeat: no-repeat;
  mask-position: center;
  background: rgba(0, 0, 0, 1);

  @media (prefers-color-scheme: dark) {
    background: rgba(255, 255, 255, 1);
  }
`
